/**
 * Attack Path tokens.
 *
 * Source: Figma "Attack Path Background" group.
 * https://www.figma.com/design/LJdrBxmaROpXg0hLW3GKe6/AiStrike-Complete-Design-System?node-id=23-476
 *
 * Each attack-path node type has a stroke (border / accent) and a filled
 * (background) color. These power the AttackPathLegend organism and any
 * graph/diagram visuals.
 */

export interface AttackPathNodeColor {
  /** Human-readable label for legends. */
  label: string;
  /** Stroke / border / accent color. */
  stroke: string;
  /** Fill / background color. */
  fill: string;
}

export const attackPathNodes = {
  impacted: { label: 'Impacted', stroke: '#BA1358', fill: '#BA1358' },
  host: { label: 'Host', stroke: '#36C5F0', fill: '#103B48' },
  role: { label: 'Role', stroke: '#C8511B', fill: '#4E2A1A' },
  policy: { label: 'Policy', stroke: '#3F8624', fill: '#26351F' },
  action: { label: 'Action', stroke: '#D3D3D3', fill: '#363636' },
  resource: { label: 'Resource', stroke: '#12264D', fill: '#3D7FFF' },
} as const satisfies Record<string, AttackPathNodeColor>;

export type AttackPathNodeType = keyof typeof attackPathNodes;

/** Ordered list for rendering legends consistently. */
export const attackPathOrder: AttackPathNodeType[] = [
  'impacted',
  'host',
  'role',
  'policy',
  'action',
  'resource',
];

export const attackPath = {
  nodes: attackPathNodes,
  order: attackPathOrder,
} as const;
